import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientApplications.scss';export default {
  "ClientApplications": "_ClientApplications_chvax_1",
  "header": "_header_chvax_1",
  "uninstallButton": "_uninstallButton_chvax_7",
  "installButton": "_installButton_chvax_10",
  "table": "_table_chvax_13",
  "cell": "_cell_chvax_13"
};